<template>
  <div>
    <table class="table table-striped mb-0">
      <tbody>
        <tr
          v-if="confinedSpacesRiskStatus.length"
          v-for="confinedSpaceRiskStatus in confinedSpacesRiskStatus"
        >
          <td>
            <span
                    class="rounded-circle px-3 py-1 mr-3"
                    :style="{
                    backgroundColor: confinedSpaceRiskStatus.color,
                    }"
            ></span>
            {{ confinedSpaceRiskStatus.name }}
          </td>
          <td class="text-right">
            {{ confinedSpaceRiskStatus.result > 0 ? confinedSpaceRiskStatus.result : '-' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      confinedSpacesRiskStatus: Array
    },
  }
</script>
